export default "__VITE_ASSET__DxBC7lSB__"